<template lang="pug">
  .table-responsive
    table#tbAceptarItems.table.is-striped.is-fullwidth
      thead
        tr
          th Aceptar
          th Categoría(s)
          th Descripción
          th Observación
      tbody
        tr(v-for="(data, index) in items" :key="data.id")
          td
            .field
              input.is-checkradio(type='checkbox' :id="data.id" @change="handleChange($event, data)" :checked="getAceptar(data)")
              label(:for="data.id") 
          td  
            span(v-html="getCats(data)")
          td 
            p.is-size-6
              b Serie: &nbsp
              | {{ data.serie }}
            p.is-size-6
              .control
                .tags.has-addons
                  span.tag.is-info
                    | {{ data.marca }}
                  span.tag.is-light
                    | {{ data.modelo}}
          td
            .field
              .control
                input.input.is-primary(
                  type='text', 
                  :placeholder="prestamo.estado === 2 ? data.o_entrega : ''",
                  @keyup.enter="saveObservaciones($event, data, index)",
                  :value="getObservacion(data)"
                  :ref="`iObs`"
                  :disabled="getEstadoObs(data)"
                )
                a.button.is-warning.is-small.is-rounded(
                  @click="editarObservacion(index)" 
                  v-show='getEstadoObs(data)'
                  ref="btnEdit"
                  :class="getEstadoObs(data) ? '' : 'is-hidden'"
                )
                  i.fas.fa-pen
                a.button.is-danger.is-small.is-rounded(
                  @click="eliminarObservacion(data)" 
                  v-show='getEstadoObs(data)'
                  ref="btnDel"
                  :class="getEstadoObs(data) ? '' : 'is-hidden'"
                ) 
                  i.fas.fa-trash
</template>

<script>
  export default {
    name: 'TbAceptarItemsPrestamo',
    props: {
      items: {
        type: Array,
        default: []
      },
      prestamo: {
        type: Object,
        default: ()=> {}
      }
    },
    methods: {
      iniciarComponente() {
        this.getEstadoObs()
      },
      getCats(data) {
        let htmlStr = ''
        if (data.subcategoria === '') {
          htmlStr = `<span class="tag is-warning">${data.categoria}</span>`
        } else {
          htmlStr = `<div class="control">
            <div class="tags has-addons">
              <span class="tag is-black">
                <i class="fas fa-tag"></i>&nbsp ${data.categoria}
              </span>
              <span class="tag is-warning"> ${data.subcategoria}
              </span>
            </div>
          </div>`
        }
        return htmlStr
      },
      handleChange(e, data) {
        if (e.target.checked) {
          console.log(e.target.checked)
          this.$emit('aceptarItem', data)
        } else {
          console.log(e.target.checked)
          this.$emit('rechazarItem', data)
        }
      },
      saveObservaciones(e, data, index) {
        console.log(e.target.value)
        console.log(data)
        let myObj = {
          id: data.id,
          id_articulo: data.id_articulo,
          categoria: data.categoria, 
          subcategoria: data.subcategoria, 
          observacion: e.target.value
        }
        console.log(myObj)
        e.target.setAttribute('disabled', true)
        const buttonEdit = this.$refs.btnEdit[index]
        buttonEdit.classList.remove('is-hidden')
        const buttonDel = this.$refs.btnDel[index]
        buttonDel.classList.remove('is-hidden')
        this.$emit('saveObservacion', myObj)
      },
      editarObservacion (index) {
        const input = this.$refs.iObs[index]
        input.removeAttribute('disabled')
        const buttonEdit = this.$refs.btnEdit[index]
        buttonEdit.classList.add('is-hidden')
        const buttonDel = this.$refs.btnDel[index]
        buttonDel.classList.add('is-hidden')
      },
      eliminarObservacion (data) {
        console.log('Eliminar')
        let myObj = {
          id: data.id,
          id_articulo: data.id_articulo,
          categoria: data.categoria, 
          subcategoria: data.subcategoria
        }
        this.$emit('deleteObservacion', myObj)
      },
      getAceptar (item) {
        let acept = false
        switch (parseInt(this.prestamo.estado)) {
          case 1:
            if (parseInt(item.i_entrega) == 1) {
              acept = true
            } else {
              acept = false
            }

            break
          case 2:
            if (parseInt(item.i_recibe) == 1) {
              acept = true
            } else {
              acept = false
            }
            break
          default:
            acept = false
            break
        }
        return acept
      },
      getObservacion (item) {
        let obser = false
        switch (parseInt(this.prestamo.estado)) {
          case 0:
            obser = item.o_entrega
            break
          case 1:
            obser = item.o_entrega
            break
          case 2:
              obser = item.o_recibe
            break
          default:
            obser = ''
            break
        }
        return obser
      },
      getEstadoObs (prest) {
        switch (true) {
          case this.prestamo.estado === 1 && prest.o_entrega !== '':
            return true
          case this.prestamo.estado === 1 && prest.o_entrega === '':
            return false
          case this.prestamo.estado === 2 && prest.o_recibe !== '':
            return true
          case this.prestamo.estado === 2 && prest.o_recibe === '':
            return false
        }
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/TbAceptarItemsPrestamo.vue